import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './components/header'
import Footer from './components/footer';
// import ReactFlagsSelect from 'react-flags-select';
// import 'react-flags-select/css/react-flags-select.css';


const NotFound = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    })
    return (

        <div className="page-wrapper">
            <Header />
            <section className="blog-grid-section section-padding">
                <div className="container " style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyItems: 'center', justifyContent: 'center' }}>


                    {/* <ReactFlagsSelect
                        countries={["IR", "US", "TR", "SA"]}
                        customLabels={{ "US": "انگلیسی", "IR": "فارسی", "TR": "ترکی", "SA": "عربی" }}
                        defaultCountry="IR"
                        placeholder="انتخاب زبان"
                        showSelectedLabel={false}
                    /> */}

                    <h3>صفحه ای که به دنبال آن هستید در دسترس نیست!</h3>

                    <Link to="/">
                        <span className="arrow" />
                        برگشت به صفحه اصلی
                    </Link>
                </div>
            </section>
            <Footer />
        </div>

    );
};

export default NotFound;
